import { createFileRoute } from '@tanstack/react-router'

import { PasskeysPage } from '../../../components/pages/backoffice/passkeys-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/passkeys/')({
  component: () => (
    <PermissionChecker requiredPermissions={['passkey.register']}>
      <PasskeysPage />
    </PermissionChecker>
  ),
})
